/* eslint-disable max-len */
export default {
  'center-area-script-name': 'Mon premier script',
  'center-area-new-script-name': 'Mon nouveau script',
  'center-area-run': 'Exécuter le script',
  'center-area-link-card': 'Jumeler l\'Oxocard',
  'center-area-upload': 'Exécuter le script',
  'center-area-state-compile': 'Compiler',
  'center-area-state-link': 'Jumeler',
  'center-area-state-finish': 'Terminé',
  'center-area-button-new': 'Nouveau',
  'center-area-button-save': 'Enregistrer',
  'center-area-button-open': 'Ouvrir',
  'center-area-button-share': 'Partager',

  'left-area-toggle-button': 'Réduire le menu',
  'left-area-button-settings': 'Préférences',

  toolbox_button_create_variable: 'Nouvelle variable',
  toolbox_category_logic: 'Logique',
  toolbox_category_variables: 'Variables',
  toolbox_category_procedures: 'Fonctions',
  toolbox_category_time: 'Temps',
  toolbox_category_weather: 'Météo',
  toolbox_category_oxocard: 'Oxocard',
  toolbox_category_matrix: 'Matrice LED',
  toolbox_category_communication: 'Communication',
  toolbox_category_accelerometer: 'Accéléromètre',
  toolbox_category_bluetooth: 'Bluetooth',
  toolbox_category_speaker: 'Haut-parleur',
  toolbox_category_microphone: 'Microphone',
  toolbox_category_extras: 'Autres',

  toolbox_label_simple: '-------------------------------------------- Blocs simples  ---------------------------------------------',
  toolbox_label_advanced: '--------------------------------------------- Blocs moyen  ----------------------------------------------',
  toolbox_label_expert: '--------------------------------------------- Blocs avancés  ---------------------------------------------',
  toolbox_logic_label_conditions: '------------------------------------------ Blocs conditionnels ------------------------------------------',
  toolbox_logic_label_loops: '-------------------------------------------- Blocs de boucles ---------------------------------------------',
  toolbox_variables_label_variables: '-------------------------------------------- Blocs de variables ---------------------------------------------',
  toolbox_variables_label_calculation_and_allocation: '----------------------------------- Blocs de calcul et d\'allocation ------------------------------------',
  toolbox_variables_label_functions: '-------------------------------------------- Blocs de fonctions ---------------------------------------------',
  toolbox_variables_label_lists: '---------------------------------------------- Blocs de listes  -------------------------------------------------',
  toolbox_variables_label_pus: '------------------------------------- Blocs mémoire non volatile  --------------------------------------',
  toolbox_oxocard_label_on_off: '--------------------------------------------- Blocs On/Off  ----------------------------------------------',
  toolbox_oxocard_label_sensors: '--------------------------------------------- Blocs capteurs  -----------------------------------------------',
  toolbox_oxocard_label_update_mode: '---------------------------------------- Blocs mode mise à jour  -----------------------------------------',
  toolbox_matrix_label_colors: '--------------------------------------------- Blocs couleurs  -----------------------------------------------',
  toolbox_matrix_label_set_pixels: '------------------------------------------ Blocs réglage des pixels  -------------------------------------------',
  toolbox_matrix_label_graphics: '---------------------------------------------- Blocs graphiques  ------------------------------------------------',
  toolbox_matrix_label_text: '----------------------------------------------- Blocs texte  -------------------------------------------------',
  toolbox_matrix_label_frame_buffer: '----------------------------------------- Blocs framebuffer  -------------------------------------------',
  toolbox_matrix_label_get_pixels: '------------------------------------------- Blocs lecture des pixels  ---------------------------------------------',
  toolbox_time_label_time: '----------------------------------------------- Blocs temporels  ---------------------------------------------------',
  toolbox_time_label_online_time: '------------------------------------------ Blocs heure réseau  ---------------------------------------------',
  toolbox_communication_label_general: '-------------------------------------------- Blocs généraux  ---------------------------------------------',
  toolbox_speaker_label_play_tone: '------------------------------------------- Blocs jouer un son  -------------------------------------------',
  toolbox_speaker_label_configure_tone: '-------------------------------------- Blocs configuration du son  --------------------------------------',
  toolbox_speaker_label_volume: '------------------------------------------- Blocs volume  -------------------------------------------',
  toolbox_speaker_label_sound_effect: '----------------------------------------- Blocs effets sonores  -------------------------------------------',
  toolbox_extras_label_gpios: '---------------------------------------------- Blocs GPIO -----------------------------------------------',
  toolbox_extras_label_console: '------------------------------------------ Blocs de console -----------------------------------------',
  toolbox_extras_label_push_values: '------------------------------------------ Blocs de données -----------------------------------------',
  toolbox_extras_label_i2c: '------------------------------------------------- Blocs I2C -------------------------------------------------',

  'right-area-news': 'Lire maintenant (News)',
  'right-area-instructions': 'Mode d\'empoi',
  'right-area-simulator': 'Simulateur',
  'right-area-my-oxocards': 'Mon Oxocard',
  'right-area-worksheets': 'Fiches de travail',
  'right-area-booklet-examples': 'Livre (allemand): Achtung, fertig, Code!',
  'right-area-examples': 'Exemples',
  'right-area-blockly-console': 'Console',
  'right-area-blockly-variables': 'Données',
  'right-area-source-code': 'Code du programme',
  'right-area-feedback': 'Feedback',
  'right-area-feedback-mail-to': 'Envoies nous un email',
  'right-area-feedback-imprint': 'Informations Légales',
  'right-area-feedback-imprint-href': 'https://oxocard.ch/fr/informations-legales/',

  'right-area-toggle-button': 'Réduire le menu',
  'right-area-show': 'Manuel',
  'right-area-template': 'Modèle',
  'right-area-solution': 'Solution',

  'right-area-simulator-reset': 'Redémarrer la carte',
  simulator_unknown_function: 'n\'est pas pris en charge par le simulateur',
  simulator_compile_error: 'Erreur dans le programme',

  'right-area-my-oxocard-no-card': 'Tu n\'as pas encore jumelé de carte.',
  'right-area-my-oxocard-card-connected': 'Tu es connecté(e) à la carte {{CARD_NAME}}.',
  'right-area-my-oxocard-connect-card': 'Procède au jumelage d\'une carte',
  'right-area-my-oxocard-other-card': 'Jumeler une autre carte',
  'right-area-my-oxocard-default-image': 'Restaurer le firmware d\'usine',
  'right-area-my-oxocard-rename-card': 'Renomme la carte',
  'right-area-my-oxocard-oxoscript': 'Passer à l\'Oxoscript',

  'right-area-blockly-console-title': 'Tu trouves ici les <strong>messages texte</strong> que tu as envoyées à ton Blockly avec ton Oxocard.',
  'right-area-blockly-console-note-title': 'Remarques:',
  'right-area-blockly-console-note-text1': 'Tu pouves trouver le bloc "Envoyer texte à la console" dans la catégorie Extras.',
  'right-area-blockly-console-clear-data': 'Effacer données',
  'right-area-blockly-console-no-data': 'Pas de données',
  'right-area-blockly-console-last-data-value': 'Actuel',

  'right-area-blockly-variables-title': 'Tu trouves ici les <strong>variables</strong> que tu as envoyées à ton Blockly avec ton Oxocard.',
  'right-area-blockly-variables-note-title': 'Remarques:',
  'right-area-blockly-variables-note-text1': 'Tu pouves trouver le bloc "Envoyer la valeur à la variable" dans la catégorie Extras.',
  'right-area-blockly-variables-note-text2': 'Un maximum de 100 valeurs par variable peuvent être enregistrées et affichées.',
  'right-area-blockly-variables-public-link': 'Lien de partage',
  'right-area-blockly-variables-csv-export': 'Exportation CSV',
  'right-area-blockly-variables-clear-data': 'Effacer données',
  'right-area-blockly-variables-data-graph': 'Graphique de données',
  'right-area-blockly-variables-no-data': 'Pas de données',
  'right-area-blockly-variables-last-data-value': 'Actuel',

  'right-area-feedback-title': 'N\'hésite pas à nous faire part de tes commentaires pour que nous puissions améliorer notre Oxocard et notre éditeur Blockly:',
  'right-area-feedback-placeholder': 'Ton commentaire...',
  'right-area-feedback-email-placeholder': 'Ton adresse de courriel (facultatif)',
  'right-area-feedback-send': 'Envoyer',

  'right-area-worksheet-link-001': 'media/worksheets/A001_Blockly2_fr.pdf',
  'right-area-worksheet-link-002': 'media/worksheets/A002_Blockly2_fr.pdf',
  'right-area-worksheet-link-003': 'media/worksheets/A003_Blockly2_fr.pdf',
  'right-area-worksheet-link-004': 'media/worksheets/A004_Blockly2_fr.pdf',
  'right-area-worksheet-link-005': 'media/worksheets/A005_Blockly2_fr.pdf',
  'right-area-worksheet-link-006': 'media/worksheets/A006_Blockly2_fr.pdf',
  'right-area-worksheet-link-007': 'media/worksheets/A007_Blockly2_fr.pdf',
  'right-area-worksheet-link-008': 'media/worksheets/A008_Blockly2_fr.pdf',
  'right-area-worksheet-link-009': 'media/worksheets/A009_Blockly2_fr.pdf',
  'right-area-worksheet-link-010': 'media/worksheets/A010_Blockly2_fr.pdf',
  'right-area-worksheet-link-011': 'media/worksheets/A011_Blockly2_fr.pdf',
  'right-area-worksheet-link-012': 'media/worksheets/A012_Blockly2_fr.pdf',
  'right-area-worksheet-link-013': 'media/worksheets/A013_Blockly2_fr.pdf',
  'right-area-worksheet-link-014': 'media/worksheets/A014_Blockly2_fr.pdf',
  'right-area-worksheet-link-015': 'media/worksheets/A015_Blockly2_fr.pdf',
  'right-area-worksheet-link-016': 'media/worksheets/A016_Blockly2_fr.pdf',
  'right-area-worksheet-link-017': 'media/worksheets/A017_Blockly2_fr.pdf',
  'right-area-worksheet-link-018a': 'media/worksheets/A018a_Blockly2_fr.pdf',
  'right-area-worksheet-link-018b': 'media/worksheets/A018b_Blockly2_fr.pdf',
  'right-area-worksheet-link-019': 'media/worksheets/A019_Blockly2_fr.pdf',
  'right-area-worksheet-link-020': 'media/worksheets/A020_Blockly2_fr.pdf',
  'right-area-worksheet-link-021': 'media/worksheets/A021_Blockly2_fr.pdf',
  'right-area-worksheet-link-022': 'media/worksheets/A022_Blockly2_fr.pdf',
  'right-area-worksheet-link-023': 'media/worksheets/A023_Blockly2_fr.pdf',
  'right-area-worksheet-link-024': 'media/worksheets/A024_Blockly2_fr.pdf',
  'right-area-worksheet-link-025': 'media/worksheets/A025_Blockly2_eng.pdf',
  'right-area-worksheet-link-026': 'media/worksheets/A026_Blockly2_fr.pdf',
  'right-area-worksheet-link-027': 'media/worksheets/A027_Blockly2_fr.pdf',

  'right-area-news-link-june2019': 'media/news/june_2019_fr.pdf',
  'right-area-news-link-september2019': 'media/news/september_2019_fr.pdf',
  'right-area-news-link-november2019': 'media/news/november_2019_fr.pdf',
  'right-area-news-link-december2019': 'media/news/december_2019_fr.pdf',
  'right-area-news-link-august2020': '',
  'right-area-news-link-february2021': 'media/news/february_2021_fr.pdf',

  'right-area-instructions-video-link': 'https://www.youtube.com/playlist?list=PLSZShxI-zRnt12wnWJQLNeH1xT0acsMzD',
  'right-area-instructions2018-video-link': 'https://youtu.be/Nk_VvHbkCj4',
  'right-area-instructions-link': 'media/instructions/instructions_2019_fr.pdf',
  'right-area-instructions2018-link': '',
  'right-area-instructions-key-commands-link': '',

  'right-area-open-in-oxoscript': 'Ouvrir dans l\'éditeur Oxoscript',

  popupSettingsEditorTitle: 'Préférences',
  popupSettingsEditorPositiveButton: 'Enregistrer',
  user_settings_expertModeActive: 'Activer le mode expert',
  user_settings_showInstructions: 'Afficher les bulles d\'aide',
  user_settings_showAlwaysOldInstructions: '&emsp;&emsp;Ne montrer que les bulles d\'aide de la version 2018',
  user_settings_uiLanguageV1: 'Langue préférée',
  user_settings_uiLanguageV1_option_de: 'Deutsch',
  user_settings_uiLanguageV1_option_en: 'English',
  user_settings_uiLanguageV1_option_fr: 'Français',

  defaultPopupTitle: 'Conseil',
  defaultPopupPositiveButton: 'OK',
  defaultPopupNegativeButton: 'Annuler',
  defaultPopupContinueButton: 'Continuer',

  // no connectivity popup
  popupNoConnectivityTitle: 'Tu n\'as pas de connectivité Internet',
  popupNoConnectivityBody: 'Pas de souci! Dès que ta cnnexion est rétablie, cette fenêtre disparaît dès que la connexion est rétablie.',

  // API not reachable popup
  popupApiNotReachableTitle: 'Notre serveur ne semble pas accessible',
  popupApiNotReachableBody: 'Vous ne pouvez pas télécharger de programmes sur votre Oxocard pour le moment. Veuillez réessayer dans quelques minutes.',

  // API reachable again popup
  popupApiReachableAgainTitle: 'Notre serveur semble à nouveau accessible',
  popupApiReachableAgainBody: 'Vous pouvez maintenant télécharger à nouveau des programmes sur votre Oxocard.',

  // no cards popup
  popupNoCardsTitle: 'Il n\'y a aucune Oxocard connectée',
  popupNoCardsBody: 'Pas de souci! Veux-tu en connecter une?',
  popupShareButtonNoCardsBody: 'Pour partager ton script, tu dois connecter une Oxocard.<br>Veux-tu en connecter une?',
  popupNoCardsNo: 'Non',
  popupNoCardsYes: 'Oui, volontiers!',

  // connect popup
  connectPopupTitle: 'Connecte une Oxocard',
  connectPopupContent: 'Saisis le code couleur affiché sur ton Oxocard.',
  connectPopupConnectButton: 'Connecter',

  // connect success popup
  popupConnectSuccessTitle: 'Ton Oxocard est à présent jumelée!',
  popupConnectSuccessBody: 'Tu as jumelé ton Oxocard avec succès.<br />Tu peux maintenant la programmer.',
  popupConnectSuccessOK: 'Super!',

  // connect error popup
  popupConnectErrorTitle: 'Nous n\'avons malheureusement pas pu trouver ton Oxocard',
  popupConnectErrorBody: 'Il y a eu un souci quelque part. Veux-tu faire une nouvelle tentative?',
  popupConnectErrorNo: 'Non merci...',
  popupConnectErrorYes: 'Oui, volontiers!',

  // feedback success popup
  popupFeedbackSuccessBody: 'Ton commentaire nous est bien parvenu! Nous t\'en remercions.',
  popupFeedbackSuccessOK: 'Bien reçu!',

  // feedback failure popup
  popupFeedbackErrorBody: 'Ton commentaire n\'a malheureusement pas pu nous être transmis. Tu peux nous écrire un courriel à <a href=\'mailto:info@oxocard.ch\'>info@oxocard.ch</a>',
  popupFeedbackErrorClose: 'Fermer',

  // save before quit popup
  popupSaveBeforeQuitText: 'Tu as encore des blocs non enregistrés. Veux-tu vraiment continuer?',

  // compilation error popup
  popupCompilationFailedTitle: 'Erreur lors de la compilation',
  popupCompilationFailedBody: 'Il y a malheureusement eu un problème. Vérifie que tes blocs sont bien corrects.',

  // flashing error popup
  popupFlashingFailedTitle: 'Erreur de transmission à l\'Oxocard',
  popupFlashingFailedBody: 'Il y a malheureusement eu un problème pour flasher ton Oxocard. Veux-tu recommencer?',
  popupFlashingFailedNo: 'Non',
  popupFlashingFailedYes: 'Oui',

  // update available popup
  popupUpdateAvailableTitle: 'Une nouvelle version est disponible',
  popupUpdateAvailableBody: 'Si tu le désires - et nous te le conseillons - tu peux maintenant procéder à une mise à jour.',
  popupUpdateAvailableNo: 'Non',
  popupUpdateAvailableYes: 'Oui volontiers!',

  // unsaved changes popup
  popupUnsavedChangesTitle: 'Tu as un programme non sauvegardé!',
  popupUnsavedChangesBody: 'Si tu continues sans enregistrer, tu vas perdre tes modifications. Veux-tu continuer?',
  popupUnsavedChangesCancel: 'Non!',
  popupUnsavedChangesContinue: 'Continuer',

  // really unpair popup?
  popupUnpairTitle: 'Ton oxocard sera déconnecté.',
  popupUnpairBody: 'Tu peux les relier à tout moment. Veux-tu continuer?',
  popupUnpairNo: 'Non',
  popupUnpairYes: 'Oui!',

  /* Popup - Really reset */
  popup_really_reset_title: 'Tu veux vraiment réinitialiser la carte?',
  popup_really_reset_body: 'Si tu appuies sur Remettre, toutes les données envoyées à parti de ton Oxocard seront supprimées. Si tu places ton Oxocard en mode de mise à jour, le programme par défaut sera restauré.',
  popup_really_reset_cancel: 'Non!',
  popup_really_reset_continue: 'Remettre',

  /* Popup - Switch to Oxoscript */
  popup_switch_to_oxoscript_title: 'Tu préfères programmer du code texte?',
  popup_switch_to_oxoscript_body: 'Si tu passes à l\'éditeur Oxoscript, le lien vers Blockly sera résolu. Tu peux toujours revenir en arrière.',
  popup_switch_to_oxoscript_cancel: 'Rester dans Blockly',
  popup_switch_to_oxoscript_continue: 'Basculer vers l\'Éditeur',

  /* Popup - Really clear data */
  popup_really_clear_data_title: 'Tu veux vraiment supprimer ces données?',
  popup_really_clear_data_body: 'Si tu appuies sur Oui, toutes les données de cette variable seront definitivement supprimées.',
  popup_really_clear_data_cancel: 'Non',
  popup_really_clear_data_continue: 'Oui',

  /* Popup - Really delete variable */
  popup_really_delete_variable_title: 'Pas de données disponibles. Tu veux supprimer la variable?',
  popup_really_delete_variable_body: 'Si tu appuies sur Oui, la variable sera definitivement supprimée.',
  popup_really_delete_variable_cancel: 'Non',
  popup_really_delete_variable_continue: 'Oui',

  // pairing instructions
  popupPairingInstructionsBody: 'En utilisant la touche de combinaison et la séquence affichée ci-dessus,<br />tu peux connecter ta carte.',
  popupPairingInstructionsCheckbox: 'Ne plus montrer cette aide',

  // pairing instructions 2019
  popupPairingInstructions2019Body: 'Appuie sur le bouton affiché ci-dessus jusqu\'à l\'apparition du symbole de jumelage.',
  popupPairingInstructions2019Checkbox: 'Ne pas afficher cette aide à l\'avenir',

  // stage instructions
  popupUpdatingBody: 'En utilisant la touche de combinaison et la séquence affichée ci-dessus,<br />tu peux basculer ta carte en mode mise à jour.',
  popupUpdatingCheckbox: 'Ne plus montrer cette aide',
  popupUpdatingButtonCancel: 'Annuler',
  popupUpdatingButtonContinue: 'Poursuivre',

  // Update mode instructions
  popupUpdateModeInstructionsBody: 'En utilisant la touche de combinaison et la séquence affichée ci-dessus,<br />tu peux basculer ta carte en mode mise à jour.',
  popupUpdateModeInstructionsButtonOK: 'Continuer',

  // Update mode instructions 2019
  popupUpdateModeInstructions2019Body: 'Appuie sur le bouton affiché ci-dessus jusqu\'à l\'apparition du symbole de mise à jour.',
  popupUpdateModeInstructions2019ButtonOK: 'Terminé',

  // invalid block-state popup
  popupInvalidBlocksFailedTitle: 'Tes blocs ne sont pas correctement arrangés',
  popupInvalidBlocksFailedBody: 'Tu devrais recontrôler tous tes blocs.<ul><li>Se pourrait-il qu\'il y ait aucun ou plusieurs points d\'entrée?</li><li>As-tu des blocs qui ne sont pas intégrés correctement?</li><li>Y aurait-il des blocs cachés en-dehors de ton champ de vision actuel ou derrière d\'autres blocs?</li></ul>',
  popupInvalidBlocksFailedIgnore: 'Ignorer',
  popupInvalidBlocksFailedRetry: 'Corriger',

  popupDefaultImageSuccessBody: 'Le programme a été préparé pour l\'Oxocard. Bascule ta carte en mode mise à jour pour le télécharger.',
  popupDefaultImageSuccessCancel: 'Terminé',
  popupDefaultImageSuccessOK: 'Mode mise à jour',

  popupDefaultImageFailureBody: 'Nous avons rencontré un problème durant la réinitialisation de la carte. Refais une tentative.',
  popupDefaultImageFailureOK: 'Fermer',

  // set name popup
  popupSetNameTitle: 'Nouveau nom pour ton Oxocard',
  popupSetNameSave: 'Enregistrer',
  popupSetNameAvailable: 'Ce nom est disponible.',
  popupSetNameNotAvailable: 'Ce nom a malheureusement déjà été attribué.',
  popupSetNameHint: '<p>Nous avons apporté des modifications fondamentales au composant de communication. De ce fait, tu dois renommer ton Oxocard pour qu\'elle soit identifiable de manière unique. Cela te permet de communiquer plus facilement avec tes contacts Oxocard. </p><p>Malheureusement, ton Oxocard ne possède pour le moment pas un nom unique. Tu peux nous laisser choisir un nom anonymisé aléatoire ou en choisir un toi-même.</p>',
  popupSetNameRules: '<p>Tu dois respecter les règles suivantes:<p><ul><li>Pas de caractère d\'espacement (espace, tabulation, ...)</li><li>Pas de caractère spécial</li><li>Au maximum 8 et au plus 30 catactères</li><li>Au moins un chiffre</li></ul>',
  popupSetNameNotValid: 'Ce nom ne respecte pas les règles.',
  popupSetNameRandom: 'Au hasard',
  popupSetNameLabel: 'Nouveau nom',

  // set name success popup
  popupSetNameSuccessTitle: 'Ton Oxocard a été renommée',
  popupSetNameSuccessBody: 'Tu as renommé ton Oxocard avec succès.<br />Tu peux maintenant la programmer.',
  popupSetNameSuccessOK: 'Super!',

  // set name error popup
  popupSetNameErrorTitle: 'Nous n\'avons pas pu renommer ton Oxocard',
  popupSetNameErrorBody: 'Il y a eu un souci quelque part. Veux refaire une tentative?',
  popupSetNameErrorNoClient: 'Il y a eu quelque part un problème avec la structure de données de ton Oxocard. Tu dois donc reprocéder à sa connexion.',
  popupSetNameErrorNo: 'Non merci...',
  popupSetNameErrorYes: 'Oui, volontiers!',

  // publish script popup
  popupShareCodeTitle: 'Ton lien a été généré!',
  popupShareCodeBody: 'Partage ce lien avec tes amis ou sauve-le dans tes favoris.',
  popupShareCodeCloseButton: 'Fermer',
  popupShareCodeCopyButton: 'Copier le lien',
  popupShareCodeCopyButtonFeedbackPositive: 'Le lien a été copié!',
  popupShareCodeCopyButtonFeedbackNegative: 'Le lien n\'a pas été copié!',
  popupShareCodeEmailButton: 'Envoyer par e-mail',
  publishScriptEmailSubject: 'Jette un oeil à mon script',

  popupShareCodeFailedTitle: 'Quelque chose s\'est mal passé',
  popupShareCodeFailedBody: 'Malheureusement, ton lien n\'a pas pu être généré. Refais une tentative plus tard.',
  popupShareCodeFailedButton: 'Fermer',

  // invalid hash popup
  popupInvalidHashTitle: 'Impossible d\'ouvrir le script',
  popupInvalidHashBody: 'La cause de ce problème peut être que le lien n\'est pas correct. Il est aussi possible qu\'il ne soit plus valide.',
  popupInvalidHashClose: 'Fermer',

  // firmware selection
  popupFirmwareSelectionTitle: 'Quelle est la version du micrologiciel (firmware) actuellement installé sur ton Oxocard?',
  popupFirmwareSelectionBody2019: '<h3><b>Version 2019</b></h3><p>Si tu vois le logo Oxocard animé après une réinitialisation, tu pousses le bouton ci-dessous.<br></p>',
  popupFirmwareSelectionBody2018: '<h3><b>Version 2018</b></h3><p>Si tu vois directement un smiley ou le logo Oxocard après une réinitialisation, tu pousses le bouton ci-dessous.</p>',
  popupFirmwareSelectionButton: 'Poussez ici',

  // old firmware version
  popupOldFwVersionTitle: 'Ton Oxocard est à présent jumelée!',
  popupOldFwVersionMessage: 'Cependant, nous avons apporté des changements fondamentaux. Veuillez télécharger le dernier firmware en mettant votre oxocard en mode de mise à jour. Ensuite, vous devez re-lier votre Oxocard.',

  // news
  news: 'Nouvelles',
  newsJune2019LinkPDF: 'Juin 2019',
  newsSeptember2019LinkPDF: 'Septembre 2019',
  newsNovember2019LinkPDF: 'Novembre 2019',
  newsDecember2019LinkPDF: 'Décembre 2019',
  newsAugust2020LinkPDF: '',
  newsFebruary2021LinkPDF: 'Février 2021',
  newsLastUpdate: 'Dernière update',

  // instructions
  instructions: 'Premiers pas pour mettre en route ton Oxocard',
  instructionsButtonVideo: 'Vidéo',
  instructionsButtonPDF: 'Manuel de l\'utilisateur (PDF)',
  instructions2018LinkPDF: '',
  instructions2018LinkVideo: '',
  instructionsKeyCommands: '',
  instructionsTitle: 'Présentation rapide de Blockly',
  instructions01: 'Les blocs de programmation peuvent être choisis à gauche parmi les différentes catégories et glissées dans l\'espace de travail de droite.',
  instructions02: 'Si tu clic et maintien dans l\'espace de travail, tous les blocs peuvent être déplacés ensemble.',
  instructions03: 'Un programme blockly commence en-haut et se termine en-bas. Il est exécuté bloc par bloc.',
  instructions04: 'Tous les blocs du programme doivent être collés ensemble (clic audible lorsque deux blocs sont bien collés).',
  instructions05: 'Dès que le dernier bloc a été exécuté, la carte s\'éteint. Si ton programme n\'atteint jamais de bloc final en raison d\'une boucle infinie, la carte s\'éteint après deux minutes.',
  instructions06: 'Si tu appuies simultanément sur les boutons L2 et L3 (Les deux boutons du bas à gauche), tu redémarres l\'Oxocard et ton programme.',
  instructions07: 'Si tu appuies sur le bouton L1 (bouton du haut à gauche) de manière prolongée et que tu maintiens appuyés courtement les boutons R2 et R3 (les deux boutons du bas à droite) de manière simultanée, l\'Oxocard s\'éteint.',
  instructions08: 'Dans les paramètres, tu peux activer le mode expert de l\'éditeur Blockly qui met tous les blocs à disposition.',

  // worksheet templates
  worksheetTemplate01: 'Fiche de travail 01 - Image formée de pixels',
  worksheetTemplate02: 'Fiche de travail 02 - Écriture défilante',
  worksheetTemplate03: 'Fiche de travail 03 - Animation',
  worksheetTemplate04: 'Fiche de travail 04 - Couleurs',
  worksheetTemplate05: 'Fiche de travail 05 - Commandes graphiques',
  worksheetTemplate06: 'Fiche de travail 06 - Machine à Smiley',
  worksheetTemplate07: 'Fiche de travail 07 - Livret de 9',
  worksheetTemplate08: 'Fiche de travail 08 - Conditions',
  worksheetTemplate09: 'Fiche de travail 09 - Hasard',
  worksheetTemplate10: 'Fiche de travail 10 - Piano digital',
  worksheetTemplate11: 'Fiche de travail 11 - Accélération',
  worksheetTemplate12: 'Fiche de travail 12 - Angles',
  worksheetTemplate13: 'Fiche de travail 13 - Kaléidoscope',
  worksheetTemplate14: 'Fiche de travail 14 - Curseur',
  worksheetTemplate15: 'Fiche de travail 15 - Programme météorologique',
  worksheetTemplate16: 'Fiche de travail 16 - Le réveil',
  worksheetTemplate17: 'Fiche de travail 17 - Le microphone',
  worksheetTemplate18a: 'Fiche de travail 18a - Communication I : envoyer *',
  worksheetTemplate18b: 'Fiche de travail 18b - Communication II : recevoir *',
  worksheetTemplate19: 'Fiche de travail 19 - Liste',
  worksheetTemplate20: 'Fiche de travail 20 - Fonctions',
  worksheetTemplate21: 'Fiche de travail 21 - Snake simplifié',
  worksheetTemplate22: 'Fiche de travail 22 - Communication locale *',
  worksheetTemplate23: 'Fiche de travail 23 - Communication locale 2 *',
  worksheetTemplate24: 'Fiche de travail 24 - Communication globale *',
  worksheetTemplate25: 'Fiche de travail 25 - Feu de circulation',
  worksheetTemplate26: 'Fiche de travail 26 - Sensor data',
  worksheetTemplate27: 'Fiche de travail 27 - Print',

  communicationWorksheets: '* Pour ces travaux pratiques, deux Oxocards sont nécessaires',

  // worksheet solutions
  worksheetSolution01: 'Solution 01 - Image formée de pixels',
  worksheetSolution02: 'Solution 02 - Écriture défilante',
  worksheetSolution03: 'Solution 03 - Animation',
  worksheetSolution04: 'Solution 04 - Couleurs',
  worksheetSolution05: 'Solution 05 - Commandes graphiques',
  worksheetSolution06: 'Solution 06 - Machine à Smiley',
  worksheetSolution07: 'Solution 07 - Livret de 9',
  worksheetSolution08: 'Solution 08 - Conditions',
  worksheetSolution09: 'Solution 09 - Hasard',
  worksheetSolution10: 'Solution 10 - Piano digital',
  worksheetSolution11: 'Solution 11 - Accélération',
  worksheetSolution12: 'Solution 12 - Angles',
  worksheetSolution13: 'Solution 13 - Kaléidoscope',
  worksheetSolution14: 'Solution 14 - Curseur',
  worksheetSolution15: 'Solution 15 - Programme météorologique',
  worksheetSolution16: 'Solution 16 - Le réveil',
  worksheetSolution17: 'Solution 17 - Le microphone',
  worksheetSolution18a: 'Solution 18a - Communication I : envoyer',
  worksheetSolution18b: 'Solution 18b - Communication II : recevoir',
  worksheetSolution19: 'Solution 19 - Liste',
  worksheetSolution20: 'Solution 20 - Fonctions',
  worksheetSolution21: 'Solution 21 - Snake simplifié',
  worksheetSolution22: 'Solution 22 - Communication locale',
  worksheetSolution23: 'Solution 23 - Communication locale 2',
  worksheetSolution24: 'Solution 24 - Communication globale',
  worksheetSolution25: 'Solution 25 - Feu de circulation',
  worksheetSolution26: 'Solution 26 - Sensor data',
  worksheetSolution27: 'Solution 27 - Print',

  // booklet exercises
  bookletExerciseTemplate01: 'Travail 01 - Image monochrome',
  bookletExerciseTemplate02: 'Travail 02 - Animation',
  bookletExerciseTemplate03a: 'Travail 03a - Commandes graphiques',
  bookletExerciseTemplate03b: 'Travail 03b - Commandes graphiques',
  bookletExerciseTemplate03c: 'Travail 03c - Commandes graphiques',
  bookletExerciseTemplate04: 'Travail 04 - Fleur',
  bookletExerciseTemplate05a: 'Travail 05a - Machine à Smiley',
  bookletExerciseTemplate05b: 'Travail 05b - Smiley avec l\'inclinaison',
  bookletExerciseTemplate06: 'Travail 06 - Compte à rebours',
  bookletExerciseTemplate07: 'Travail 07 - Séries de nombres',
  bookletExerciseTemplate08: 'Travail 08 - Animation avec une boucle',
  bookletExerciseTemplate09: 'Travail 09 - Colorier une image',
  bookletExerciseTemplate10a: 'Travail 10a - Mélodie',
  bookletExerciseTemplate10b: 'Travail 10b - Piano digital',
  bookletExerciseTemplate11: 'Travail 11 - Sons et bruitages',
  bookletExerciseTemplate12: 'Travail 12 - Dé électronique',
  bookletExerciseTemplate13: 'Travail 13 - Pixels aléatoires',
  bookletExerciseTemplate14: 'Travail 14 - Sons aléatoires',
  bookletExerciseTemplate15: 'Travail 15 - Pixel en chute',
  bookletExerciseTemplate16: 'Travail 16 - Hasard',
  bookletExerciseTemplate17: 'Travail 17 - Roulis et inclinaison',
  bookletExerciseTemplate18: 'Travail 18 - Attrape le pixel',
  bookletExerciseTemplate19a: 'Travail 19a - Horloge simple',
  bookletExerciseTemplate19b: 'Travail 19b - Horloge simple (Exercice supplémentaire)',
  bookletExerciseTemplate20_s: 'Travail 20 - Petits messages (envoyer)',
  bookletExerciseTemplate20_r: 'Travail 20 - Petits messages (recevoir)',

  // booklet solutions
  bookletExerciseSolution01: 'Solution 01 - Image monochrome',
  bookletExerciseSolution02: 'Solution 02 - Animation',
  bookletExerciseSolution03a: 'Solution 03a - Commandes graphiques',
  bookletExerciseSolution03b: 'Solution 03b - Commandes graphiques',
  bookletExerciseSolution03c: 'Solution 03c - Commandes graphiques',
  bookletExerciseSolution04: 'Solution 04 - Fleur',
  bookletExerciseSolution05a: 'Solution 05a - Machine à Smiley',
  bookletExerciseSolution05b: 'Solution 05b - Smiley avec l\'inclinaison',
  bookletExerciseSolution06: 'Solution 06 - Compte à rebours',
  bookletExerciseSolution07: 'Solution 07 - Séries de nombres',
  bookletExerciseSolution08: 'Solution 08 - Animation avec une boucle',
  bookletExerciseSolution09: 'Solution 09 - Colorier une image',
  bookletExerciseSolution10a: 'Solution 10a - Mélodie',
  bookletExerciseSolution10b: 'Solution 10b - Piano digital',
  bookletExerciseSolution11: 'Solution 11 - Sons et bruitages',
  bookletExerciseSolution12: 'Solution 12 - Dé électronique',
  bookletExerciseSolution13: 'Solution 13 - Pixels aléatoires',
  bookletExerciseSolution14: 'Solution 14 - Sons aléatoires',
  bookletExerciseSolution15: 'Solution 15 - Pixel en chute',
  bookletExerciseSolution16: 'Solution 16 - Hasard',
  bookletExerciseSolution17: 'Solution 17 - Roulis et inclinaison',
  bookletExerciseSolution18: 'Solution 18 - Attrape le pixel',
  bookletExerciseSolution19a: 'Solution 19a - Horloge simple',
  bookletExerciseSolution19b: 'Solution 19b - Horloge simple (Exercice supplémentaire)',
  bookletExerciseSolution20_s: 'Solution 20 - Petits messages (envoyer)',
  bookletExerciseSolution20_r: 'Solution 20 - Petits messages (recevoir)',

  // example titles
  exampleTitleSimple: 'Facile',
  exampleTitleAdvanced: 'Moyen',
  exampleTitleExpert: 'Expert (Jeux)',

  // examples
  exampleNameSmiley: 'Smiley',
  exampleTemplateSmiley: 'Exemple - Smiley',
  exampleNameWink: 'Clignement',
  exampleTemplateWink: 'Exemple - Clignement',
  exampleNameFalling_pixel: 'Pixel en chute',
  exampleTemplateFalling_pixel: 'Exemple - Pixel en chute',
  exampleNameKaleidoscope: 'Kaléidoscope',
  exampleTemplateKaleidoscope: 'Exemple - Kaléidoscope',
  exampleNamePiano: 'Piano digital',
  exampleTemplatePiano: 'Exemple - Piano digital',
  exampleNameSimple_communication: 'Communication simple (2 cartes nécessaires)',
  exampleTemplateSimple_communication: 'Exemple - Communication simple',
  exampleNameRainbow: 'Arc-en-ciel',
  exampleTemplateRainbow: 'Exemple - Arc-en-ciel',
  exampleNameWeather: 'Météo',
  exampleTemplateWeather: 'Exemple - Météo',
  exampleNameBattery: 'Batterie',
  exampleTemplateBattery: 'Exemple - Batterie',
  exampleNameHangman: 'Jeu du pendu',
  exampleTemplateHangman: 'Exemple - Jeu du pendu',
  exampleNameMoving_pixel: 'Pixel en mouvement',
  exampleTemplateMoving_pixel: 'Exemple - Pixel en mouvement',
  exampleNameRain: 'Pluie',
  exampleTemplateRain: 'Exemple - Pluie',
  exampleNameLong_image: 'Longue image',
  exampleTemplateLong_image: 'Exemple - Longue image',
  exampleNameWhistle: 'Sifflet',
  exampleTemplateWhistle: 'Exemple - Sifflet',
  exampleNameNoise_meter: 'Mètre de bruit',
  exampleTemplateNoise_meter: 'Exemple - Mètre de bruit',
  exampleNameLocal_communication: 'Communication locale (2 cartes nécessaires)',
  exampleTemplateLocal_communication: 'Exemple - Communication locale',
  exampleNameGlobal_communication: 'Communication globale (2 cartes nécessaires)',
  exampleTemplateGlobal_communication: 'Exemple - Communication globale',
  exampleNameCarousel: 'Jeu du carousel',
  exampleTemplateCarousel: 'Exemple - Jeu du carousel',
  exampleNamePainter: 'Peintre',
  exampleTemplatePainter: 'Exemple - Peintre',
  exampleNameColor_game: 'Memory (Jacques a dit)',
  exampleTemplateColor_game: 'Exemple - Memory (Jacques a dit)',
  exampleNameDrop_game: 'Drop the Game',
  exampleTemplateDrop_game: 'Exemple - Drop the Game',
  exampleNameRock_Paper_Scissors: 'Pierre-papier-ciseaux (2 cartes nécessaires)',
  exampleTemplateRock_Paper_Scissors: 'Exemple - Pierre-papier-ciseaux',
  exampleNameMini_Pong: 'Mini Pong',
  exampleTemplateMini_Pong: 'Exemple - Mini Pong',

  // Editor
  settingsFeatureIntroTitle: 'Montrer les nouvelles fonctions lors du chargement de l\'éditeur?',
  settingsFeatureIntroNew: 'Nouveautés',
  settingsFeatureIntroAlways: 'Toujours montrer',
  settingsFeatureIntroNever: 'Ne jamais montrer',
  feedback: 'Merci de nous envoyer un petit feedback pour que nous puissions améliorer notre Oxocard et notre éditeur:',
  rebootCard: 'Redémarrer la carte',
  shutDownCard: 'Éteindre la carte',
  documentation: 'Documentation',
  searchDocumentation: 'Chercher dans la documentation',
  clearOutput: 'Effacer',
  output: 'Sortie',
  cmdTimedOutTitle: 'La commande prend trop de temps à s\'exécuter.',
  cmdTimedOutMsg: 'Ta carte est-elle connectée?',
  wsConnection: 'Connexion Web Sockets',
  cardConnection: 'Connexion à la carte',
  editorMenuTitle: 'Éditeur',
  editorThemeLight: 'Clair',
  editorThemeDark: 'Foncé',
  settingsEditorTheme: 'Changer le thème de l\'éditeur:',
  toasts: {
    wsOpenSuccess: 'Connexion Websocket établie avec succès',
    wsOpenFail: 'Nous n\'avons pas pu établir la connexion Websocket',
    cardOpen: 'La connexion avec la carte a été établie',
    cardClose: 'La connexion avec la carte a été interrompue',
    cardPairSuccess: 'La connexion avec la carte a été établie avec succès',
    cardPairFail: 'Nous n\'avons pas pu établir la connexion avec la carte',
    feedbackSuccess: 'Merci pour ton feedback',
    feedbackFail: 'Le feedback n\'a pas pu être envoyé.',
    runFileResponse: 'Résultat du fichier exécuté. Clique ici pour plus de détails ...',
    runFileError: 'Le programme n\'a pas pu être exécuté',
    runFileSuccess: 'Le programme a été exécuté avec succès',
  },
  legacyVersionPopupTitle: 'Version périmée',
  legacyVersionPopupBody: 'Il semble que tu aies une version périmée du micro-logiciel sur ton Oxocard. Pour pouvoir utiliser l\'éditeur, tu dois d\'abord la mettre à jour.',

  // TODO: translate
  errorCode0: 'After \'def\' you have to define a function name.',
  errorCode1: 'There is a missing \'(\'-symbol.',
  errorCode2: 'There is a missing \')\'-symbol.',
  errorCode3: 'Variables need a data-type. Choose between \'int\', \'char\', or \'byte\'',
  errorCode4: 'There is a missing or unknown statement.',
  errorCode5: '\'=\', \'(\' or \'+=\' expected.',
  errorCode6: '\'++\' or \'--\' expected.',
  errorCode7: 'Unknown function name. Check the spelling of the name.',
  errorCode8: 'There is a missing \'(\'-symbol.',
  errorCode9: 'There is a missing \')\'-symbol.',
  errorCode10: 'Numeric value expected.',
  errorCode11: 'The function expects a list variable or a string, but you pass an int/char/byte variable',
  errorCode12: 'This function has no parameters, but you tried to passed some values.',
  errorCode13: 'You passed a wrong number of parameters.',
  errorCode14: '\']\' expected.',
  errorCode15: 'Return is not value in event procedures. Use \'exit\' instead.',
  errorCode16: 'There is a missing \')\'-symbol.',
  errorCode17: 'The variable is not declared. Check the spelling.',
  errorCode18: '] expected but not found.',
  errorCode19: 'You have to use a list type here.',
  errorCode20: 'There is a missing \')\'-symbol.',
  errorCode21: 'There was an error in a expression.',
  errorCode22: 'There is a missing \')\'-symbol.',
  errorCode23: 'There is a missing \')\'-symbol.',
  errorCode24: 'Each statement must be terminated by a Newline or a semicolon (\';\')',
  errorCode25: 'You cannot set a value here on global variables. Only allowed in functions.',
  errorCode26: 'Place a colon (\':\') here with indentation.',
  errorCode27: 'Error in for-statement: for IDENT in list: statements',
  errorCode28: 'Use a simple variable after \'for\', list types are not allowed here.',
  errorCode29: '\'in\' expected.',
  errorCode30: 'Indexed access requires a known/declared variable.',
  errorCode31: 'After for ..in - a list, integer variable or a number is expected.',
  errorCode32: 'Array types are not allowed here.',
  errorCode33: '\'=\' expected.',
  errorCode34: 'This variable is already in use.',
  errorCode35: 'Global numeric variables can only initialize to 0.',
  errorCode36: 'Global list variables can only initialize to [].',
  errorCode37: 'Def functions or global variable declarations expected.',
  errorCode38: 'Comma expected.',
  errorCode39: 'After a colon, the lines must be indented.',
};
